import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  SimpleChanges,
  Inject
} from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { GlobalComponent } from "../../global/global.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  IFilter,
  GridComponent,
  QueryCellInfoEventArgs,
  FilterSettingsModel
} from "@syncfusion/ej2-angular-grids";
import { DropDownList } from "@syncfusion/ej2-angular-dropdowns";
import {
  SearchSettingsModel,
  ToolbarItems,
  DataStateChangeEventArgs,
  EditEventArgs,
  Column,
  TextWrapSettingsModel
} from "@syncfusion/ej2-grids";
import {
  sortingObj,
  GetAgencyBO,
  AgencyInfoBO,
  AgencyListBO,
  WhereCondition,
  SaveReturnBO,
  IsViewEdit,
  CompanyList,
  functionpermission,
  saveHHAXAggregatorCredential,
  GetAggregatorBO,
  AgencyNoteBO,
  type,
} from "./agency.model";
import { ToastrService } from "ngx-toastr";
import { AgencyService } from "./agency.service";
import { GetHTTPServiceAgency } from "../agency/agencylistData.service";
import { Observable, Subject } from "rxjs";
import { Tooltip } from "@syncfusion/ej2-angular-popups";
import { ColumnChangeBO, columnWidth, GetListBO } from "../list/list.model";
import { CommonHttpService } from "src/app/common.service";
import { takeUntil } from "rxjs/operators";
import { GeneralService } from "src/app/service/general.service";
import { AggregatorService } from "./aggregator-data.service";
import { CommonApiService } from 'src/app/commonapiservice';
import { DatePipe } from '@angular/common';
import { Router } from "@angular/router";
import { SftpEventBo } from "../sftp/sftp.modal";
@Component({
  selector: "app-agency",
  templateUrl: "./agency.component.html",
  styleUrls: ["./agency.component.scss"],
})

export class AgencyComponent implements OnInit {
  @ViewChild("grid") public grid: GridComponent;
  @ViewChild('gridHHAX') public gridHHAX: GridComponent;
   // Notes

  public datanotesforagency: Observable<DataStateChangeEventArgs>;
  public formatOptions1: object;
  initialPage1: object;
  Notes: any = new AgencyNoteBO();
  notetype: type = new type();
  filterOptions1: FilterSettingsModel;
  @ViewChild('gridnotesforagency') public gridnotesforagency: GridComponent;
  ColumnArray_agencynotes: columnWidth[];
  getAgencyNotes: GetListBO = new GetListBO();
  typelst: type[] = [];
  deleteNoteId: number;
  typedropdown = [];
  noteLst: AgencyNoteBO[] = [];
  NotesAgencyDataList: any = [];
  TypeNotesDataList: any = [];


  /////===============Array initialisation=====================///
  Agencylist: AgencyListBO[];
  statusList: any = [];
  agencyStatusList: any = [];
  public toolbar: ToolbarItems[];
  arraycol: any = [];
  ColumnArray: columnWidth[];
  conditionlist: WhereCondition[] = [];
  valuechange: any = [];
  stateList: any = [];
  companyList: any = [];
  argschooser = [];
  AggregatorData: any = [];
  ///////////////=============Object initialization==========//
  AgencyGroup: FormGroup;
  notesForm: FormGroup;
  isSaveorUpdateBoolean:boolean=false;
  private onDestroy$: Subject<void> = new Subject<void>();
  Agency: AgencyListBO = new AgencyListBO();
  toCompanylist: IsViewEdit = new IsViewEdit();
  ListSendBO: GetAgencyBO = new GetAgencyBO();
  conditionData: WhereCondition = new WhereCondition();
  fp: functionpermission = new functionpermission();
  saveHHAXInfo: saveHHAXAggregatorCredential = new saveHHAXAggregatorCredential();

  companyEmit: boolean = false;
  typenumberAutoIcreament: number;
  isSuperAdmin: boolean = false;
  agencyId: string;
  isEdit: boolean = false;
  openAgency = false;
  SearchText: string = "";
  url: any = {};
  agencyLogoShow: Boolean = false;
  imgType: any = "";
  imgSize: number = 0;
  imageErr: any = "";
  ModelType: string = "edit";
  agencyFilter: string;
  alphaErr: boolean = false;
  saveErr: string = "";
  type: string = "";
  
  ViewEdit: IsViewEdit = {
    isView: true,
    isEdit: true,
    isEditCompany: false,
    editCompanyId: "00000000-0000-0000-0000-000000000000",
    AgencyId: this.Agency.id,
    CompanyData: new CompanyList(),
  };

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string = "00000000-0000-0000-0000-000000000000";

  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  initialPage: object;
  public filterSettings: object;
  filter: IFilter;
  public wrapSettings: TextWrapSettingsModel;
  pagshort: sortingObj = new sortingObj();
  public dropdata: string[];
  public data: Observable<DataStateChangeEventArgs>;
  public AsDataGridList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  public height = "220px";
  $: any;

  public formatOptions: object;
  AggregatorBO: GetAggregatorBO = new GetAggregatorBO();
  isViewAggregator: boolean = false;
  isViewSFTP: boolean = false;
  SFtpEvent: SftpEventBo = new SftpEventBo();
  constructor(public http: HttpClient,
    public CommonAPI: CommonApiService,
    public datepipe: DatePipe,
    public aggregatorService: AggregatorService,
    public commonhttp: CommonHttpService,
    private formBuilder: FormBuilder,
    @Inject(GetHTTPServiceAgency) public gethttp: GetHTTPServiceAgency,
    private ref: ChangeDetectorRef,
    public global: GlobalComponent,
    public httpService: AgencyService,
    public toastrService: ToastrService,
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,public router:Router) {

      this.datanotesforagency = CommonAPI;
      this.global.checkforlogout();
      this.data = gethttp;
      this.notetype.id = "00000000-0000-0000-0000-000000000000"
    this.AsDataGridList = aggregatorService;
    this.AgencyGroup = this.formBuilder.group({
      agencyCode: ["", [Validators.required, Validators.minLength(4)]],
      agencyName: ["", Validators.required],
      agencyShortName: ["", Validators.required],
      agencyLogo: [""],
      email: ["", [Validators.required, Validators.email]],
      phone: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      street: [""],
      city: [""],
      state: [""],
      zipCode: [""],
      altStreet: [""],
      altCity: [""],
      altState: [""],
      altZipcode: [""],
      statusLid: ["", Validators.required],
      fax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      id: ["00000000-0000-0000-0000-000000000000"],
    });

    this.notesForm = this.formBuilder.group({
      date: ["", Validators.required],
    });

    if (this.global.isClientNewTab) {
      this.router.navigateByUrl("/Client");
    
    }

  }

  ngOnInit() {
    this.getStatusDropDown();
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    this.wrapSettings = { wrapMode: "Content" };
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.isSuperAdmin =
          this.global.agencyCode.toUpperCase() == "SUPERADMIN";
        this.stateList = data;
      });

    this.conditionlist.push(new WhereCondition());
    this.toolbar = ["ColumnChooser"];
    this.filterSettings = { type: "Menu" };
    this.filter = {
      type: "Excel",
    };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Agency");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  actionHandler(args) {
    if (args.requestType == "sorting") {
    } else if (args.requestType == "filtering") {
    }
  }

  actionBegin(args: EditEventArgs) {
    for (const cols of this.grid.columns) {
      if ((cols as Column).field === "Status") {
        (cols as Column).visible = true;
      } else if ((cols as Column).field === "ShipCountry") {
        (cols as Column).visible = false;
      }
    }
  }
  //===================================Show column settings===================//
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    let f = changes;
  }

  public dataStateChange(state): void {
    this.type = state.action.requestType.toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType =
          state.sorted[0].direction === "descending" ? "desc" : "asc";
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
      this.ListSendBO.type = 'string'
      state.action.currentFilterObject.field === "phone"
        ? (state.action.currentFilterObject.value =
          state.action.currentFilterObject.value
            .replace(" ", "")
            .replace("(", "")
            .replace(")", "")
            .replace("-", ""))
        : state.action.currentFilterObject.value;
      if (this.ListSendBO.type == "number") {
        this.ListSendBO.value =
          state.action.currentFilterObject.value.toString();
        this.ListSendBO.field = state.action.currentFilterObject.field;
      } else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      if (state.action.currentFilterObject.field == "statusLidName") {
        this.ListSendBO.value = this.statusList
          .filter((e) => e.Value == state.action.currentFilterObject.value)[0]
          .Key.toString();
        this.ListSendBO.field = "statusLidName";
        this.ListSendBO.statusLid = this.statusList?.filter(
          (e) => e.Value == state.action.currentFilterObject.value
        )[0].Key;
        this.ListSendBO.type = "number";
      }
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
    } else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "AgencyName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
      }
    }
    this.getAgencyList();
    this.SearchText= '';
    if (this.type == "paging" && state.action.name == "actionBegin") {
    }
  }

  AgencyCreateupdate(type: string) {
    if (
      this.global.globalHeadAgencyId ==
      "00000000-0000-0000-0000-000000000000" ||
      this.global.globalHeadAgencyId == null ||
      this.global.globalHeadAgencyId == undefined ||
      this.global.globalHeadAgencyId == ""
    ) {
      if (type == "new") {
        document.getElementById("openModal").click();
        this.AgencyGroup.reset();
        this.Agency = new AgencyListBO();
        this.ModelType = "new";
        this.AgencyGroup.controls.statusLid.setValue(
          this.statusList.filter((st) => st.Value == "Active")[0].Key
        );
        this.Agency.statusLid = this.statusList.filter(
          (st) => st.Value == "Active"
        )[0].Key;
      } else {
        this.ModelType = "edit";
        this.agencyId = this.Agency.id;
      }

      this.valueschanges();
    } else {
      if (type == "new") {
        this.toastrService.error(
          "Please Clear Agency Dropdown",
          "To Create Agency"
        );
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    }
  }
  ////////////////////////////////////////////////////
  selectAgencydetails(data) {
    this.Agency = JSON.parse(JSON.stringify(data));
    this.AgencyGroup.patchValue(data);
    this.AgencyGroup.value.id = data.id;
  }
  ////////////////////////////////////////////////////////////

  DemographicPhoneFormat(value) {
    if (value == "phone") {
      this.Agency.phone = this.general.converPhoneGoogleLib(this.Agency.phone);
      this.AgencyGroup.value.phone = this.Agency.phone;
    } else if (value == "fax") {
      this.Agency.fax = this.general.converPhoneGoogleLib(this.Agency.fax);
      this.AgencyGroup.value.fax = this.Agency.fax;
    }
  }

  Refresh() {
    this.SearchText = "";
    this.ListSendBO.matchCase = false;
    this.ListSendBO.operator = "startswith";
    this.ListSendBO.value = this.SearchText;
    this.ListSendBO.type = "string";
    this.ListSendBO.field = "AgencyName";
    this.ListSendBO.statusLid = this.statusList.filter(
      (st) => st.Value == "Active"
    )[0].Key;
    this.ListSendBO.currentpageno = 1;
    this.pagshort = new sortingObj();
    this.grid.pageSettings.currentPage = 1;
    this.getAgencyList();
  }

  getStatusDropDown() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.httpService
      .getLovStatus(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.statusList = JSON.parse(JSON.stringify(data));
        this.statusList.forEach((ele) => {
          ele.Key = ele.id;
          ele.Value = ele.lovName;
          delete ele.id;
          delete ele.lovCode;
          delete ele.lovName;
          delete ele.lovValue;
        });
        this.agencyStatusList = data;
        let values = {
          id: null,
          lovName: "All",
          lovCode: "ALL",
          lovValue: "ALL",
        };
        this.agencyStatusList.push(values);
        this.ListSendBO.statusLid = this.agencyStatusList?.filter(
          (st) => st.lovName == "Active"
        )[0].id;

        this.gethttp.execute(this.ListSendBO);
        let count = 0;
        this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
          count = count + 1;
          if (data != null && data != undefined && count == 1) {
          }
        });
      });
  }
  // ============================================================================
  getAgencyList() {
    this.gethttp.execute(this.ListSendBO);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      count = count + 1;

      if (data != null && data != undefined && count == 1) {
      }
    });
  }
  paginationChange(event) {
    this.pagshort.currentPgNo = event;
    this.getAgencyList();
  }
  // /////////////////////////////////////////////////////////////
  pageItemsChage(pageitems) {
    this.pagshort.itemperpage = pageitems;
    this.getAgencyList();
  }
  // // //////////////////////////////////////////////////////////////
  Search() {
    this.pagshort.currentPgNo = 1;
    this.getAgencyList();
  }
  // // ///////////////////////////////////////////////////////////
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }

  SaveOrUpdateAgency() {
    this.isSaveorUpdateBoolean=true;
    var saveList: AgencyListBO = JSON.parse(
      JSON.stringify(this.AgencyGroup.value)
    );
    saveList.statusLid = saveList.statusLid;
    if (this.ModelType == "new") {
      this.AgencyGroup.value.id = "00000000-0000-0000-0000-000000000000";
    } else {
      saveList.id = this.Agency.id;
    }
    saveList.id = this.AgencyGroup.value.id;
    if (saveList.phone != null) {
      saveList.phone = this.general.reconverPhoneGoogleLib(saveList.phone);
    }
    if (saveList.fax != null) {
      saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);
    }
    this.httpService
      .saveupdate(saveList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: SaveReturnBO) => {
          this.isSaveorUpdateBoolean=false;
          if (data) {
            //====================== sucess message =============
            if (saveList.id == "00000000-0000-0000-0000-000000000000") {
              this.global.globalHeadAgencyId =
                "00000000-0000-0000-0000-000000000000";
              saveList.id = data.agencyId;
              this.agencyId = data.agencyId;

              this.Agency = saveList;
              this.getAgencyList();
              this.getOverallAgencyDropDown();
              this.toastrService.success(
                "Agency created successfully",
                "Agency created"
              );
              document.getElementById("openModal").click();
              this.getAgencyList();
              setTimeout(() => {
                this.toastrService.clear();
              }, 8000);
              this.valueschanges();
              this.ModelType = "edit";
            } else {
              this.getAgencyList();
              this.getOverallAgencyDropDown();
              if (this.Agency.id == this.global.globalAgencyId) {
                let myparams = new URLSearchParams();
                myparams.append("agencyId", this.global.globalAgencyId);
                this.httpService
                  .getOverAllAgencyInfo(myparams)
                  .pipe(takeUntil(this.onDestroy$))
                  .subscribe((data: AgencyInfoBO) => {
                    if (data != null) {
                      this.global.agencyLogo = data.agencyLogo;
                      this.global.agencyName = data.agencyName;
                      this.global.selectAgencyCode = data.agencyCode;
                      if (data.phone != null) {
                        data.phone = this.general.reconverPhoneGoogleLib(
                          data.phone
                        );
                        this.global.agencyPhone =
                          this.general.converPhoneGoogleLib(data.phone);
                      }

                      data.agencyId = this.global.globalAgencyId;
                      localStorage.setItem(
                        "CFSS_globalagencydetails",
                        JSON.stringify(data)
                      );
                    }
                  });
              }
              this.toastrService.success(
                "Agency updated successfully",
                "Agency updated"
              );
              this.getAgencyList();
              setTimeout(() => {
                this.toastrService.clear();
              }, 8000);

              this.valueschanges();
              document.getElementById("openModal").click();
            }
          } else {
            this.saveErr = data.errorList[0];
            if (this.saveErr != "") {
              setTimeout(
                function () {
                  this.saveErr = "";
                }.bind(this),
                8000
              );
            }
          }
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          if (err) {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        }
      );
  }

  getStatesField() {
    this.commonhttp
      .getJSON()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.stateList = data;
      });
  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Agency.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });

          this.arraycol[0].Agency.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });

          if (showarr.length != count1 || hidearr.length != count) {
            this.arraycol[0].Agency.ShowColumns = showarr;
            this.arraycol[0].Agency.HideColumns = hidearr;
          }
        }
      }
    }

    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      this.ListSendBO.type = args.columnType;
      args.columns.forEach((element) => {
        this.conditionlist.push(element.properties);
      });
    }
  }

  valueschanges() {
    this.valuechange = {
      Img: 0,
      Status: 0,
      AgencyName: 0,
      Code: 0,
      ShortName: 0,
      Email: 0,
      Phone: 0,
      Street: 0,
      City: 0,
      State: 0,
      Zip: 0,
      Alt_Street: 0,
      Alt_City: 0,
      Alt_State: 0,
      Alt_Zipcode: 0,
    };
  }
  checkpopup(value) {
    if (value == "Img") {
      this.valuechange.Img++;
    }
    if (value == "statusLid") {
      this.valuechange.Status++;
    }
    if (value == "agencyName") {
      this.valuechange.AgencyName++;
    }
    if (value == "agencyCode") {
      this.valuechange.Code++;
    }
    if (value == "agencyShortName") {
      this.valuechange.ShortName++;
    }
    if (value == "email") {
      this.valuechange.Email++;
    }
    if (value == "phone") {
      this.valuechange.Phone++;
    }
    if (value == "street") {
      this.valuechange.Street++;
    }
    if (value == "city") {
      this.valuechange.City++;
    }
    if (value == "IvrAgencyId") {
      this.valuechange.IvrAgencyId++;
    }
    if (value == "state") {
      this.valuechange.State++;
    }
    if (value == "zipCode") {
      this.valuechange.Zip++;
    }
    if (value == "altStreet") {
      this.valuechange.Alt_Street++;
    }
    if (value == "altCity") {
      this.valuechange.Alt_City++;
    }
    if (value == "altState") {
      this.valuechange.Alt_State++;
    }
    if (value == "altZipcode") {
      this.valuechange.Alt_Zipcode++;
    }

    if (value == "fax") {
      this.valuechange.Fax++;
    }
  }

  ////---- ADD/VIEW/EDIT EVENTS FROM COMPANY TABLE VIEW HANDLER
  closeFun() {
    document.getElementById("openModal").click();
    document.getElementById("closemodal").click();
  }

  openDialog() {
    if (
      this.valuechange.Code > 1 ||
      this.valuechange.Img > 0 ||
      this.valuechange.Status > 1 ||
      this.valuechange.AgencyName > 1 ||
      this.valuechange.ShortName > 1 ||
      this.valuechange.Email > 1 ||
      this.valuechange.Phone > 2 ||
      this.valuechange.Street > 1 ||
      this.valuechange.City > 1 ||
      this.valuechange.State > 1 ||
      this.valuechange.Zip > 1 ||
      this.valuechange.Alt_State > 1 ||
      this.valuechange.Alt_City > 1 ||
      this.valuechange.Alt_Street > 1 ||
      this.valuechange.Alt_Zipcode > 1 ||
      this.valuechange.Fax > 1
    ) {
      document.getElementById("cancelmodal").click();
    } else {
      document.getElementById("openModal").click();
    }
  }
  //=================================== Upload image & preview image function ===================================
  onSelectFile(event) {
    this.imgSize = 0;
    this.imgType = event.target.files[0].type;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      if (event.target.files[0].size < 51200) {
        reader.onload = this.handleReaderLoaded.bind(this);
      } else {
        this.imageErr = "";
        this.imageErr = "File size should be less than 50kb";
        this.imgSize = event.target.files[0].size;
        setTimeout(() => {
          if (this.imageErr != "") {
            this.imageErr = "";
          }
        }, 5000);
      }
    }
  }

  base64textString: any = "";
  handleReaderLoaded(readerEvt) {
    this.agencyLogoShow = true;
    this.Agency.agencyLogo = readerEvt.target.result;
    var binaryString = readerEvt.target.result;
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //============================================get agency overall drop down============//
  getOverallAgencyDropDown() {
    this.httpService
      .getOverAllAgency()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: AgencyListBO[]) => {
        this.global.globalAgencyDropDown = [];
        this.global.globalAgencyDropDown = data;
        this.global.ngAgencyDropDown = this.global.globalAgencyDropDown;
        this.global.ngAgencyDropDown?.forEach((a) => (a.id = a.id));
        this.global.globalAgencyDropdown = this.global.globalAgencyId;
      });
  }

  filterchange() {
    this.ListSendBO.statusLid = this.agencyStatusList?.filter(
      (st) => st.lovName == "Active"
    )[0].id;
    this.ListSendBO.value = this.SearchText;
    this.ListSendBO.pageitem = this.grid.pageSettings.pageSize;
    this.getAgencyList();
  }

  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip(
          {
            content: args.data[args.column.field].toString(),
            position: "RightCenter",
          },
          args.cell as HTMLTableCellElement
        );
      }
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }

  checkfirstLetter(event, agencycode) {
    if (agencycode != undefined) {
      let char = agencycode?.toLowerCase();

      if (char.charAt(0) && !(char >= "a")) {
        this.alphaErr = true;
      } else {
        this.alphaErr = false;
      }
    } else {
      this.alphaErr = false;
    }
  }

  numbersOnly(event) {
    if (!this.global.isdigit(event.key)) {
      event.preventDefault();
    }
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  ////---- ADD/VIEW/EDIT EVENTS FROM COMPANY TABLE VIEW HANDLER
  dataEmitfromChild(event: IsViewEdit) {
    this.isEdit = event.isEdit;
    this.ViewEdit.AgencyId = this.Agency.id;
    this.ViewEdit = event;
  }
 


  agencyToEdit(event: IsViewEdit) {
    this.toCompanylist.isView = event.isView;
    this.toCompanylist = event;
    this.toCompanylist.AgencyId = this.Agency.id;
  }

  companyConfig(value) {
    this.toCompanylist.isView = true;
    this.toCompanylist.AgencyId = value.id;
    this.global.globalHeadAgencyId = value.id;
    this.agencyId = value.id;
  }
  //...........................................getDetails............................................................
  getDetails(AggList) {
    this.saveHHAXInfo = JSON.parse(JSON.stringify(AggList));
  }
  //.....................................................showAggregator..............................................
  showAggregator() {
    this.gridHHAX.columnChooserModule.openColumnChooser(200, 50);
  }
  //........................................SaveorUpdateHHAXAggregator...........................................................
  SaveorUpdateHHAXAggregator() {
    let saveHHAX = JSON.parse(JSON.stringify(this.saveHHAXInfo));
    this.aggregatorService.saveHHAXCredentialAsync(saveHHAX).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (saveHHAX.id == "00000000-0000-0000-0000-000000000000") {
        this.toastrService.success(
          "Aggregator saved successfully!"
        );
      }
      else {
        this.toastrService.success(
          "Aggregator updated successfully!"
        );
      }
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);

      this.clearField();
      this.getHHAXAggregator();
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      });
  }
  //................................................clearField.........................................................
  clearField() {
    document.getElementById("openCreateorUpdateAggregator").click();
    this.saveHHAXInfo = new saveHHAXAggregatorCredential();
    this.getHHAXAggregator();
  }

  //.................................................getHHAXAggregator............................................
  getHHAXAggregator() {
    document.getElementById('openAggregator').click()
    this.AggregatorBO.agencyID = this.global.globalAgencyId;
    this.aggregatorService.executeAggregatorFilter(this.AggregatorBO);
    let count = 0;

    this.AsDataGridList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AggregatorData = data.result;
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
      }
      if (data != null && data.result.length > 15) {
        this.gridHHAX.height = '500';
      }
      else {
        this.gridHHAX.height = 'auto';
      }
    })
  }

  GetCompanyDropdown() {
    this.httpService.GetCompanyDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
      this.companyList = data;
    },
      (err: HttpErrorResponse) => {

      })
  }

  // Notes

  public onActionCompleteNotes(args) {
    this.getAgencyNotes.currentpageno = this.gridnotesforagency.pagerModule.pagerObj.currentPage;
    this.getAgencyNotes.pageitem = this.gridnotesforagency.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.getAgencyNotes.type = args.columnType
    }
  }
  public dataStateChangeNotes(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getAgencyNotes.orderColumn = "Date";
        this.getAgencyNotes.orderType = 'asc';
      }
    }
    if (this.getAgencyNotes.type == "date") {
      this.getAgencyNotes.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      this.getAgencyNotes.field = state.action.currentFilterObject.field;
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      this.getAgencyNotes.field = state.action.currentFilterObject.field;
      this.getAgencyNotes.matchCase = state.action.currentFilterObject.matchCase;
      this.getAgencyNotes.operator = state.action.currentFilterObject.operator;
      this.getAgencyNotes.value = state.action.currentFilterObject.value;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.getAgencyNotes.field = "Date";
        this.getAgencyNotes.matchCase = false;
        this.getAgencyNotes.operator = "contains";
        this.getAgencyNotes.value = "";
        this.getAgencyNotes.type = "string";
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].AgencyNotes.Pagesize != state.take) {
          this.arraycol[0].AgencyNotes.Pagesize = state.take

        }
      }
    }
    this.getNoteList();
  }
  getNoteList() {
    let val = 0;
    let url = "api/AgencyNote/GetAgencyNoteList"
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.CommonAPI.outputValues(url, this.getAgencyNotes, responseData, "");
    this.datanotesforagency.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.noteLst = data.result;
      this.NotesAgencyDataList = data.result;
      val++;
      // if (data != null && data != undefined && val == 1) {

      // }
    });
  }
  editNote(data) {
    this.Notes = data;
    this.Notes.typeListId = this.Notes.typeListId.toString()
    this.getType();
  }
  getType() {
    let url = "api/TypeList/GetTypeList?";
    let params = new URLSearchParams();
    let typefor: string = "SUPERADMIN";
    params.append("typefor", typefor);
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.TypeNotesDataList = data;
      this.typelst = JSON.parse(JSON.stringify(data));
      this.typedropdown = data;
      if (this.typedropdown.length != 0) {
        this.typedropdown.forEach((element) => { element.id = element.id.toString() })
      }
      if (this.typelst.length > 0) {
        this.typenumberAutoIcreament = Math.max.apply(Math, this.typelst.map(function (o) { return parseInt(o.typeNumber) })) + 1;
      }
      else {
        this.typenumberAutoIcreament = 1;
      }
      this.notetype.typeNumber = this.typenumberAutoIcreament;
    })
  }
  opennewnote() {

    this.getNoteList();
    this.getType();
    this.Notes = new AgencyNoteBO();
    this.Notes.id = '00000000-0000-0000-0000-000000000000';
    this.Notes.date = this.datepipe.transform(new Date(), "yyyy-MM-dd'T'HH:mm")
    this.Notes.initial = this.global.logginedUserName
    this.Notes.multipletype = []
    this.Notes.notes = ""

  }
  saveNote(data) {
    const sendata = [];
    const savedata = JSON.parse(JSON.stringify(data));
    const noteid = savedata.id;
    let url = "";

    if (noteid === '00000000-0000-0000-0000-000000000000') {
        // New note, create an array of payloads
        savedata.multipletype.forEach((typeId: string) => {
            sendata.push({
                AgencyId: this.getAgencyNotes.agencyID, // Ensure AgencyId is valid
                TypeListId: typeId, // Match backend casing
                Date: savedata.date, // Match backend casing
                Initial: savedata.initial,
                Notes: savedata.notes
            });
        });
        url = "api/AgencyNote/SaveAgencyNote"; // Endpoint for bulk insert
    } else {
        // Existing note, send a single object
        sendata.push({
            Id: savedata.id, // Include ID for updates
            AgencyId: this.getAgencyNotes.agencyID,
            TypeListId: savedata.typeListId,
            Date: savedata.date,
            Initial: savedata.initial,
            Notes: savedata.notes
        });
        url = "api/AgencyNote/SaveAgencyNote"; // Same endpoint for updates
    }

    // Debugging: Log the payload to verify its structure
    console.log("Payload to be sent:", JSON.stringify(sendata));

    // Make the API call
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(sendata, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
            (response: any) => {
                const successMessage =
                    noteid === '00000000-0000-0000-0000-000000000000'
                        ? "Notes Added successfully!"
                        : "Notes updated successfully!";
                this.toastrService.success(successMessage);

                // Clear success message after delay
                setTimeout(() => this.toastrService.clear(), 8000);

                // Refresh notes list and close modal
                this.getNoteList();
                document.getElementById("addnotesforagencyopen")?.click();
            },
            (error: any) => {
                // Handle errors
                this.toastrService.error("An error occurred while saving the note.", "Error");
                console.error("Error Response:", error);

                // Clear error message after delay
                setTimeout(() => this.toastrService.clear(), 8000);
            }
        );
}

savetype(data: any) {
  let savedata = JSON.parse(JSON.stringify(data));
  let typeid = savedata.id;
  let url = "api/TypeList/SaveTypeList?";

  this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(savedata, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
          (response: any) => {
              if (typeid === '00000000-0000-0000-0000-000000000000') {
                  // If the type ID is the default GUID (indicating a new type)
                  this.toastrService.success(
                      "Type Added successfully!",
                      "Type Added"
                  );
              } else {
                  // If the type ID is not the default GUID (indicating an update)
                  this.toastrService.success(
                      "Type Updated successfully!",
                      "Type Updated"
                  );
              }

              // Clear the toast after 8 seconds
              setTimeout(() => {
                  this.toastrService.clear();
              }, 8000);

              // Close the modal and refresh the list
              document.getElementById("addtypeforagencyopen")?.click();
              this.getType();
          },
          (err: any) => {
              // Show error toast if something goes wrong
              this.toastrService.error(
                  err.message || "An error occurred!",
                  "Error"
              );

              // Clear the toast after 8 seconds
              setTimeout(() => {
                  this.toastrService.clear();
              }, 8000);
          }
      );
}

  deleteNote() {
    let param = new URLSearchParams();
    param.append("Id", this.deleteNoteId.toString());
    let url = "api/AgencyNote/DeleteAgencyNote?";

    // Trigger the delete operation
    this.CommonAPI.DeleteFunctionForDeleteHttp(param, url).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data) => {
        // After successful deletion, refresh the note list and show a success message
        this.getNoteList();
        this.toastrService.success(
          "Note Deleted Successfully!",
          "Notes Deleted"
        );
      },
      (err: any) => {
        // Handle errors if the deletion fails
        this.toastrService.error(
          err,
          "Error"
        );
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }
  
  opennote(dat) {
    this.getAgencyNotes.agencyID = dat.id;
    this.getNoteList();
  }
  showColumn() {
    this.gridnotesforagency.columnChooserModule.openColumnChooser(200, 50);
  }

  onResizeNotes(args) {
    if (this.ColumnArray != undefined && this.ColumnArray != null) {
      const column = this.gridnotesforagency.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });

    }
  }

  addnewtype() {
    this.notetype.id = '00000000-0000-0000-0000-000000000000';
    this.notetype.typeName = '';
    this.notetype.typeFor = "SUPERADMIN";
    this.notetype.agencyId = null;
  }



}
